export default __webpack_public_path__ + "b9e9c363b8a495b25cc95a5425c0ff7f.png";